/* eslint-disable  @typescript-eslint/no-explicit-any */
import type { PipeMiddlewareElement } from '../../middleware-pipe';
import type { MiddlewarePipeDetails } from '../../models/middleware-pipe-details.model';
import type { SearchTab } from '../../../../components/result-page/search-tab/search-tab';
import type { CoseQueryBodyRequest, FilterRequest } from '../../../../models/cose-api/request/query-body-request.model';
import { coseFacetsMapper, mapCharacteristics } from '../../../mappers/cose/cose-facets-mapper';
import mapFacetNames from '../../../../helpers/mapFacetNames';
import mapFacetNamesV2 from '../../../../helpers/mapFacetNames-v2';
import { firstValueFrom } from 'rxjs';
import { makeLogger } from '../../../../logger/logger';
import { FacetsService } from '../../../services/facets/facets.service';
import type { PipeMiddlewareNext } from '../../middleware-pipe';

const { debug } = makeLogger({
  pathToCurrentFile:'utils/middleware-pipe/pipes/cose/req-res-cose-facet-query-facet-mapping.ts',
  loggersList: ['debug']
});

export const reqResCoseFacetQueryFacetMappingV2: PipeMiddlewareElement<MiddlewarePipeDetails, any> = async (
  details: MiddlewarePipeDetails,
  next: PipeMiddlewareNext<any>,
  middlewareDepth: number,
  middlewareArray: Array<PipeMiddlewareElement<MiddlewarePipeDetails, any>>
): Promise<any> => {
    const searchTab: SearchTab = details.context;
    const updateOnlyMobileStates = !!details.config.updateOnlyMobileStates;

    let facetRequestState: FilterRequest[] = (updateOnlyMobileStates)
      ? await firstValueFrom(searchTab.facetsV2Service.facetsMobileService.facetsRequestState)
      : (details.context.facetsConfigDataParamsGetter.isNewFacetsLogic || (details.context.facetsConfigDataParamsGetter.isMobileFiltering && searchTab.mobileView))
        ? await firstValueFrom(searchTab.facetsV2Service.facetsRequestState)
        : await firstValueFrom(searchTab.facetService.facetsRequestState);

    const searchFilters: FilterRequest[] = [];
    if(details.context.horizontalFilterPanel){
      if(details.context.searchFacetsValuesToRemove?.length > 0 && details.context.searchFacetsValuesToRemove !== undefined){
        details.context.filtersChips = details.context.filtersChips.filter(x => {
            const existingFacetToRemove = details.context.searchFacetsValuesToRemove?.find(facet => facet == x.id);
            if(existingFacetToRemove){
              return;
            }
            return x;
        });
      }

      const filtersChips = details.context.filtersChips;
      if(filtersChips?.length > 0){
        facetRequestState = facetRequestState?.filter(facet => {
            const existingChipsets = filtersChips.filter(x => x.id == facet.id);
            if(existingChipsets !== undefined && existingChipsets.length > 0){
              const chipsetValues = existingChipsets.map(x => x.facetValue);
              facet.children = facet.children.filter(facetChildren => chipsetValues.indexOf(facetChildren.value) !== -1);
            }
            else{
              return;
            }

            if(facet.children.length === 0){
              details.context.filtersChips = details.context.filtersChips.filter(x => x.id !== facet.id);
              return;
            };

            return facet;
        });
      }else{
        if(!updateOnlyMobileStates) {
          searchTab.facetsV2Service.setFacets(null);
          searchTab.facetsV2Service.setFacetsState([]);
          searchTab.facetsV2Service.setFacetsRequestState([]);
        } else {
          searchTab.facetsV2Service.facetsMobileService.setFacets(null);
          searchTab.facetsV2Service.facetsMobileService.setFacetsState([]);
          searchTab.facetsV2Service.facetsMobileService.setFacetsRequestState([]);
        }
        /**
         * OLD Facets Service reset states (to remove after all tabs on new facets logic)
         */
        searchTab.facetService.setFacets(null);
        searchTab.facetService.setFacetsState([]);
        searchTab.facetService.setFacetsRequestState([]);
        /**
         * OLD Facets Service reset states (to remove after all tabs on new facets logic)
         */
        facetRequestState = [];
      }
    }

    if(details.context.searchFacetsValues.length > 0){
      details.context.searchFacetsValues.map(filter => {
          const facetId = filter.id ? filter.id : filter.facetName;
          const existingFacet = facetRequestState.find(x => x.id == facetId);
          if(!existingFacet){
            const existingFacetToRemove = details.context.searchFacetsValuesToRemove?.find(x => x == facetId);
            if(!existingFacetToRemove){
              searchFilters.push({
                id: filter.id,
                children: [{
                  value: filter.facetValue,
                  children:[]
                }]
              });
            }
          }else{
            if(existingFacet.children.length === 0){
              existingFacet.children.push({
                value: filter.facetValue,
                children: []
              });
            }
          }

          const existingChip = details.context.filtersChips.find(x => x.id === filter.id);
          if(existingChip){
            existingChip.facetValue = filter.facetValue;
            existingChip.value = filter.facetValue;
          }else{
            const existingFacetToRemove = details.context.searchFacetsValuesToRemove?.find(x => x == facetId);
            if(!existingFacetToRemove){
              filter.value = filter.facetValue;
              details.context.filtersChips.push(filter);
            }
          }
      });
    }

    if(searchFilters.length > 0) {
      facetRequestState = facetRequestState.concat(searchFilters);
    }

    if(facetRequestState.length > 0) {
      (details.middlewareRequest.requestBody as CoseQueryBodyRequest).filters = [...facetRequestState];
    }

    if(details?.additionalData && details?.additionalData?.forcedFilters) {
      let newFacetsState = [...FacetsService.setUnique(facetRequestState)];
      newFacetsState = newFacetsState.concat([...details.additionalData.forcedFilters]);
      const merged = FacetsService.mergeArrayQueries(newFacetsState);
      if(!updateOnlyMobileStates) {
        searchTab.facetsV2Service.setFacetsState(JSON.parse(JSON.stringify(merged)));
        searchTab.facetsV2Service.setFacetsRequestState(JSON.parse(JSON.stringify(merged)));
      } else {
        searchTab.facetsV2Service.facetsMobileService.setFacetsState(JSON.parse(JSON.stringify(merged)));
        searchTab.facetsV2Service.facetsMobileService.setFacetsRequestState(JSON.parse(JSON.stringify(merged)));
      }

      /**
       * OLD Facets Service update state and request state (to remove after all tabs on new facets logic)
       */
      searchTab.facetService.setFacetsState(JSON.parse(JSON.stringify(merged)));
      searchTab.facetService.setFacetsRequestState(JSON.parse(JSON.stringify(merged)));
      /**
       * OLD Facets Service update state and request state (to remove after all tabs on new facets logic)
       */

      (details.middlewareRequest.requestBody as CoseQueryBodyRequest).filters = FacetsService.clearTreeUnique(merged) as FilterRequest[];
    }

    debug('reqResCoseFacetQueryFacetMapping BEFORE',JSON.stringify(details.middlewareRequest.requestBody));

    const response = await next(details);

    let newResponse = {...response};



    if(response?.facetsOptions?.facets) {
      // MUST BE ON PRODUCTION
      newResponse = { ...response, ...{ facets: coseFacetsMapper(mapCharacteristics(response?.facetsOptions?.facets)) } };

      /**
       * OLD Name mapper to remove when we use New Facets Logic
       */
      newResponse['facets'] = mapFacetNames(searchTab, newResponse['facets']);

      newResponse.facetsOptions['facets'] = mapFacetNamesV2(searchTab, newResponse.facetsOptions['facets']);
      // eslint-disable-next-line no-unsafe-optional-chaining
      const facets = [...newResponse?.facetsOptions?.facets];
      if(!updateOnlyMobileStates){
        searchTab.facetsV2Service.createUpdateChipsStateFromResponseTree(JSON.parse(JSON.stringify(facets)));
      } else {
        searchTab.facetsV2Service.facetsMobileService.createUpdateChipsStateFromResponseTree(JSON.parse(JSON.stringify(facets)));
      }
      /**
       * OLD Facets Service update chips (to remove after all tabs on new facets logic)
       */
      searchTab.facetService.createUpdateChipsStateFromResponseTree(JSON.parse(JSON.stringify(facets)));
      /**
       * OLD Facets Service update chips (to remove after all tabs on new facets logic)
       */

      const marketingProductFacet = facets?.find(
        (facet) => facet?.id === 'badgeTypes',
      );

      if (marketingProductFacet) {
        const selectedMarketingProductValues =
        marketingProductFacet?.children?.filter(
          (child) => child?.selected === true,
        );
    
        if (selectedMarketingProductValues) {
          searchTab.parentDataFlux.root.marketingProductBadgesFilters =
          selectedMarketingProductValues?.map((child) => child?.value);
        }
      }
    }

    debug('reqResCoseFacetQueryFacetMapping AFTER',newResponse['facets']);
    if(details?.context && details?.context?.searchFacetsValuesToRemove) {
      details.context['searchFacetsValuesToRemove'] = [];
    }
    return new Promise(r=>r(newResponse));
};
